// src/RootLanding.jsx
import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useNavigate, useLocation } from "react-router-dom";

const SS = typeof window !== "undefined" ? window.sessionStorage : null;
const RETURN_TO_KEY = "tb_return_to";

export default function RootLanding() {
    const navigate = useNavigate();
    const location = useLocation();
    const { accounts, inProgress } = useMsal();
    const isAuthed = !!accounts?.[0];

    useEffect(() => {
        // If MSAL is still working (redirect callback, etc.), just wait
        if (inProgress !== InteractionStatus.None) {
            return;
        }

        // If we have a pending deep link from before login → restore it
        if (SS) {
            const pending = SS.getItem(RETURN_TO_KEY);
            if (pending) {
                SS.removeItem(RETURN_TO_KEY);
                // Only navigate if we're still on root
                const currentPath = location.pathname + location.search;
                if (currentPath === "/" || currentPath === "/index.html" || currentPath === "/index.js") {
                    window.location.replace(pending);
                    return;
                }
            }
        }

        // Only redirect to /dashboard if we are truly at root (/, /index.html, etc.)
        const path = location.pathname;
        const isRootEntry =
            path === "/" ||
            path === "/index.html" ||
            path === "/index.js" ||
            path === "";

        if (isAuthed && isRootEntry) {
            navigate("/dashboard", { replace: true });
        }

        // Otherwise: do nothing → stay on current deep link (e.g. /manage-requests/...)
        // This is the key fix!
    }, [isAuthed, inProgress, location, navigate]);

    return (
        <div className="main">
            <div className="card">Loading…</div>
        </div>
    );
}